var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhiteOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C9.33123 13.9997 10.6241 13.5541 11.6728 12.734L14.9697 16.031L16.0303 14.9705L12.7333 11.6735C13.5538 10.6247 13.9997 9.33158 14 8C14 4.69175 11.3082 2 8 2C4.69175 2 2 4.69175 2 8C2 11.3082 4.69175 14 8 14ZM8 3.5C10.4818 3.5 12.5 5.51825 12.5 8C12.5 10.4818 10.4818 12.5 8 12.5C5.51825 12.5 3.5 10.4818 3.5 8C3.5 5.51825 5.51825 3.5 8 3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhiteOutlined);
export default __webpack_public_path__ + "static/media/search_white_outlined.ed97fafdea8eb178c45a1cac15188469.svg";
export { ForwardRef as ReactComponent };